/**
 * StickyFooterButton Component
 * Fixed bottom button with mobile-safe padding
 */

import { GolfButton } from '@/components/golf/golf-button';
import { cn } from '@/lib/utils';

interface StickyFooterButtonProps {
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
}

export function StickyFooterButton({
  onClick,
  disabled = false,
  children,
  className,
  variant = 'primary'  // Fixed: was 'default' which doesn't exist in GolfButton
}: StickyFooterButtonProps) {
  return (
    <div className={cn(
      "fixed bottom-0 left-0 right-0 z-50",
      "bg-background border-t border-border",
      "p-4 pb-safe", // pb-safe for mobile safe area
      "shadow-lg"
    )}>
      <GolfButton
        onClick={onClick}
        disabled={disabled}
        variant={variant}
        className={cn("w-full", className)}
        size="lg"
      >
        {children}
      </GolfButton>
    </div>
  );
}


